import { Language } from "./langType";

export default <Language>{
  Sports: {
    "American Football": "Soka ya Marekani",
    Baseball: "Baseboli",
    Basketball: "Mchezo wa kikapu",
    Boxing: "Ndondi",
    Chess: "Chess",
    Cricket: "Kriketi",
    Darts: "Darts",
    Entertainment: "Entertainment",
    "E-Sports": "E-Sports",
    Football: "Soka",
    "Formula 1": "Formula 1",
    "Gaelic Football": "Gaelic Football",
    "Generic Sport": "Generic Sport",
    Golf: "Gofu",
    "Greyhound Racing": "Greyhound Racing",
    Handball: "Mpira wa mkono",
    "Ice Hockey": "Magongo thelujini",
    IndyCar: "IndyCar",
    MMA: "MMA",
    Nascar: "Nascar",
    Politics: "Politics",
    "Rugby League": "Ligi ya Raga",
    "Rugby Union": "Rugby Union",
    Snooker: "Snooker",
    "Table Tennis": "Tennis Mezani",
    Tennis: "Tennis",
    "Virtual Football": "Virtual Football",
    "Virtual Greyhound Racing": "Virtual Greyhound Racing",
    "Virtual Horse Racing": "Virtual Horse Racing"
  },
  MarketTexts: {
    ToWin: "{name} kushinda",
    WinFirstRound: "{name} kushinda raundi ya kwanza",
    FirstTouchdown: "{name} kupata alama ya kugusa kwanza",
    FirstTry: "{name} kupata alama ya Jaribio kwanza",
    TotalGoals: "{name} Jumla malengo",
    TotalRuns: "{name} Jumla inaendesha",
    TotalPoints: "{name} Alama za jumla",
    TopBatsman: "{name} kuwa Juu Batsman",
    TopBowler: "{name} kuwa Bowler Juu",
    FirstScore: "{name} kupata alama kwanza"
  },
  PromoTexts: {
    Pick: "Fanya chaguo zako",
    Bet: "Bet",
    Pays: "Malipo"
  },
  DateTimeTexts: {
    Today: "Leo",
    Tomorrow: "Kesho",
    Live: "Hai"
  },
  ButtonTexts: {
    Draw: "X"
  },
  ParlayTexts: {
    Picks: "Fanya chaguo zako",
    Return: "Malipo",
    Stake: "Bet",
    Draw: "X"
  },
  H2HTexts: {
    goals_scored: "Bao zilizotingwa",
    shots: "Mikwaju",
    shots_on_target: "Kulenga golini",
    ball_possession: "Kumiliki",
    goals_conceded: "Bao zilizokubaliwa",
    "Per match": "Kwa mechi",
    H2H: "H2H",
    W: "W",
    D: "D",
    L: "L",
    T: "D",
    // baseball
    runs_per_game: "Runs",
    runs_allowed_per_game: "Runs Allowed",
    hits_per_game: "Hits",
    batting_average: "AVG",
    on_base_percentage: "OBP",
    slugging_percentage: "SLG",
    home_runs: "HR",
    stolen_bases: "SB",
    earned_run_average: "ERA",
    walks_hits_per_inning_pitched: "WHIP",
    strikeouts_per_9_innings: "K/9",
    homeruns_allowed_per_game: "HR",
    batting_average_against: "BA",
    batting_stats: "Batting/Running",
    pitching_stats: "Pitching/Defence",

    // american football
    points_per_game: "Points",
    points_allowed_per_game: "Points Allowed",
    rushing_stats: "Rushing Stats",
    rushing_yards_per_game: "Rushing Yards",
    rushing_touchdowns: "Rushing Touchdowns (total)",
    rushing_percentage: "Rushing %",
    passing_stats: "Passing Stats",
    passing_yards_per_game: "Passing Yards",
    passing_touchdowns: "Passing Touchdowns (total)",
    passing_percentage: "Passing %"
  }
};
